import { Layers } from 'lucide-react';
import type { PromotionMetricsSlice } from '@/client/types/promotion';
import { money, numberFmt, type ColorScale } from './analytics';

export const CategoryBreakdown: React.FC<{ slices: PromotionMetricsSlice[]; color: ColorScale }> = ({ slices, color }) => {
  const max = Math.max(1, ...slices.map((s) => s.revenue));

  return (
    <div className="rounded-2xl border border-gray-100 bg-white p-5 shadow-sm">
      <div className="mb-4 flex items-center gap-2">
        <Layers className="h-4 w-4 text-emerald-600" />
        <h3 className="text-sm font-semibold text-gray-900">Revenue by category</h3>
      </div>

      {slices.length === 0 ? (
        <p className="py-8 text-center text-sm text-gray-400">No purchases in this period.</p>
      ) : (
        <div className="space-y-3">
          {slices.map((s) => (
            <div key={s.key}>
              <div className="mb-1 flex items-center justify-between text-sm">
                <span className="flex items-center gap-2 font-medium text-gray-700">
                  <span
                    className="h-2.5 w-2.5 rounded-full"
                    style={{ backgroundColor: color(s.key) }}
                  />
                  {s.key}
                </span>
                <span className="tabular-nums text-gray-900">{money(s.revenue)}</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="h-2 flex-1 overflow-hidden rounded-full bg-gray-100">
                  <div
                    className="h-full rounded-full"
                    style={{ width: `${(s.revenue / max) * 100}%`, backgroundColor: color(s.key) }}
                  />
                </div>
                <span className="w-24 shrink-0 text-right text-[11px] text-gray-400">
                  {(s.share * 100).toFixed(1)}% · {numberFmt.format(s.orders)} sold
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
